import { SET_AD } from "./const";

export default {

    [SET_AD](state, ad) {
        state.ad = ad
    },
}